import React from "react";

function About3() {
    return (
        <div>

            <section className="service-section bg-grey padding">
                <div className="map-pattern" />
                <div className="container">
                    <div className="section-heading text-center mb-40">
                        <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Innovative IT Solutions for a <span className="hl">Digital Future</span></h2>
                        <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">We specialize in delivering cutting-edge IT solutions designed to drive growth and efficiency. Our expertise spans across innovative technology, seamless integration, and strategic support. Partner with us to unlock new opportunities and achieve exceptional results.
                        </p>
                    </div>
                    <div className="row gy-lg-0 gy-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="service-item wow fade-in-bottom" data-wow-delay="100ms">
                                <div className="service-thumb">
                                    <img src="assets/img/about.jpg" alt="thumb" />
                                </div>
                                <div className="service-content">
                                    <div className="service-icon"><i className="fa fa-code" /></div>
                                    <h3><a>Skilled Developers</a></h3>
                                    <p>Advanced tools for expert developers. Precision and efficiency at your fingertips.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-item wow fade-in-bottom" data-wow-delay="300ms">
                                <div className="service-thumb">
                                    <img src="assets/img/about1.jpg" alt="thumb" />
                                </div>
                                <div className="service-content">
                                    <div className="service-icon"><i className="fa fa-dollar-sign" /></div>
                                    <h3><a>Competitive Pricing</a></h3>
                                    <p>Fair pricing for expert developers. Quality and value you can trust.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-item wow fade-in-bottom" data-wow-delay="500ms">
                                <div className="service-thumb">
                                    <img src="assets/img/about2.jpg" alt="thumb" />
                                </div>
                                <div className="service-content">
                                    <div className="service-icon"><i className="fa fa-clock" /></div>
                                    <h3><a>Round-the-Clock Support</a></h3>
                                    <p>24/7 support for expert developers. Assistance whenever you need it.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default About3;